"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const n=require("./index287.js");var a=n.stringMultibyte.charAt,i=function(e,t,r){return t+(r?a(e,t).length:1)};exports.advanceStringIndex=i;
